module.exports = __webpack_public_path__ + "static/media/pop_drip.854bb52e.wav";


//////////////////
// WEBPACK FOOTER
// ./src/pop_drip.wav
// module id = 55
// module chunks = 0